import {
  REMOVE_WAREHOUSE,
  SET_INVITED_ADMIN,
  SET_WAREHOUSE,
  SET_WAREHOUSE_ADMINS,
  SET_WAREHOUSES_LIST
} from "../actions/actionTypes";

const initialState = {
  warehouses: [],
  admins: [],
  warehouse: {},
  invitedAdmin: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WAREHOUSES_LIST:
      return {
        ...state,
        warehouses: action.payload.results
      };
    case SET_WAREHOUSE_ADMINS:
      return {
        ...state,
        admins: action.payload
      };
    case SET_WAREHOUSE:
      return {
        ...state,
        warehouse: action.payload
      };
    case REMOVE_WAREHOUSE:
      return {
        ...state,
        warehouses: state.warehouses.filter(warehouse => warehouse.id !== action.payload)
      };
    case SET_INVITED_ADMIN:
      return {
          ...state,
        invitedAdmin: action.payload
      };
    default:
      return state;
  }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/warehouse.js